import { useCallback } from "react";
import { useMeeting } from "../../../hooks/meeting";
import { LocalStorageKeys, videoBackgroundOptions } from "../../../types";
import classNames from "./VideoBackgrounds.module.css";

export default function VideoBackgrounds() {
  const [meeting, setMeeting] = useMeeting();

  const getOptionName = useCallback((option?: "blur") => {
    switch (option) {
      case "blur":
        return "Blur";
    }
    return "None";
  }, []);

  return (
    <div className={classNames.VideoBackgrounds}>
      {videoBackgroundOptions.map((option, index) => (
        <div
          aria-selected={meeting.media.videoBackground === option}
          onClick={() => {
            if (option) {
              localStorage.setItem(LocalStorageKeys.VIDEO_BACKGROUND, option);
            } else {
              localStorage.removeItem(LocalStorageKeys.VIDEO_BACKGROUND);
            }
            setMeeting((prevState) => ({
              ...prevState,
              media: { ...prevState.media, videoBackground: option },
            }));
          }}
          key={index}
        >
          {getOptionName(option)}
        </div>
      ))}
    </div>
  );
}
